// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

export const TooltipContainer = styled.div`
  text-align: center;
`;

export const TooltipTitle = styled.div`
  font-weight: bold;
`;

export const TooltipSubtitle = styled.div`
  font-weight: normal;
  color: var(--mb-color-text-light);
`;
